import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AddParamsInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Only for POST and PUT
        if (req.method == 'POST' || req.method == 'PUT') { // NOSONAR
            let upn
            let roles
            const userData:any = sessionStorage?.getItem('FGA');
            if (userData) {
                upn = JSON.parse(userData)?.user?.userPrincipalName;
                roles = JSON.parse(userData)?.roles
            }

            const isAdmin = roles?.some(r => r.displayName == 'Alarms Admin') ? true : false; // NOSONAR

            const newBody = {
                ...req.body,
                isAdmin: isAdmin,
                userId: JSON.parse(userData)?.user?.userId,
                userPrincipalName: upn,
                firstName: JSON.parse(userData)?.user?.firstName,
                lastName: JSON.parse(userData)?.user?.lastName,
            };

            const cloned = req.clone({
                body: newBody
            });

            return next.handle(cloned);
        }

        return next.handle(req);
    }
}
